import React from 'react'
import '../App.css';
import './Obrazovanje.css';
import Header from '../components/Header';
import Footer from '../components/Footer'

const Obrazovanje = () => {
  return (
    <div>
          <Header />
          <div className="card">
                <h3>Centar za obrazovanje odraslih Bijeljina <br />vrši kvalifikacije, dokvalifikacije i prekvalifikacije
                     za sledeća zanimanja trećeg stepena:</h3>
                <p>Frizer, Trgovac, Varilac, Konobar, Kuvar, Automehaničar, Bravar, Električar, 
                    Instalater, Limar, Kovač, Mehaničar, Vozač motornih vozila (državni ispit), 
                    Obradjivač metala rezanjem, Precizni mehaničar, Metalobrusač, Monter Rukovalac građevinskih i pretovarnih masina
                </p>
            </div>
            <div className="card">
            <h3>Centar za obrazovanje odraslih Bijeljina <br />vrši kvalifikacije, dokvalifikacije i prekvalifikacije
                     za sledeća zanimanja četvrtog stepena:</h3>
            <p>Kozmetički tehničar, Trgovački tehničar, Tehnicar drumskog saobraćaja, Ekonomski tehničar, 
                Medicinski tehničar, Tehničar elektoenergetike, Ugostiteljsko-kulinarski tehničar, Mašinski tehničar
            </p>
            </div>
            <div className="card">
            <h3>Centar za obrazovanje odraslih Bijeljina <br />vrši sledeće obuke:</h3>
            <p>Rukovodioc građevinskih mašina, Vodoinstalater, Plastenička proizvodnja, Negovatelj starijih i nemoćnih lica, 
                Armirač, Zavarivač MIG-MAG postupkom, Zavarivač TIG postupkom, Pekar, Dimnjičar, Pčelar, Trener jahanja, 
                Tesar, Zidar, Moler, Sakupljač samoniklog ljekovitog bilja, sumskih plodova i gljiva
            </p>
            </div>
          <Footer />
    </div>
  );
}

export default Obrazovanje;
